import { FC } from 'react';

import { CheckoutDesign } from '../types';

import { TOTALS } from './PreviewSection';

const PRODUCTS = [
  {
    img: 'https://media-dev.appcharge.com/media/product-3.png',
    name: 'Coins',
    value: '6580'
  },
  {
    img: 'https://media-dev.appcharge.com/media/bills.png',
    name: 'Tokens',
    value: '150'
  },
  {
    img: 'https://media-dev.appcharge.com/media/booster.png',
    name: 'Boosters',
    value: '3'
  }
];

const DesktopPreview: FC<Partial<CheckoutDesign>> = ({
  logo,
  buttonColor,
  buttonTextColor,
  primaryColor,
  textColor,
  backgroundImage
}) => {
  return (
    <div className="w-[603px] h-[539px] bg-whitesmoke border-8 border-black rounded-[19px] flex overflow-hidden">
      {/* Left panel */}
      <div
        className="flex flex-col gap-2 px-8 py-4 w-1/2"
        style={{
          background: primaryColor,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover'
        }}
      >
        <div className="mt-2 h-[68px] flex items-start">
          <img src={logo} alt="logo" className="h-12 object-contain" />
        </div>
        <div>
          <p className="text-sm font-medium" style={{ color: textColor }}>
            Crazy Pack
          </p>
          <p className="text-2xl font-semibold" style={{ color: textColor }}>
            $99.99
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <hr className="border" style={{ borderColor: textColor }} />
          {PRODUCTS.map((item) => (
            <div key={item.name} className="flex gap-1.5">
              <img src={item.img} alt="" className="w-12 h-12" />
              <div className="flex flex-col justify-center gap-1">
                <span
                  className="text-xs font-normal"
                  style={{ color: textColor }}
                >
                  {item.name}
                </span>
                <span
                  className="text-base font-semibold"
                  style={{ color: textColor }}
                >
                  {item.value}
                </span>
              </div>
            </div>
          ))}
          <hr className="border" style={{ borderColor: textColor }} />
          {TOTALS.map((row) => (
            <div
              key={row.label}
              className={`flex justify-between ${row.bold ? 'text-base font-medium' : 'text-xs font-normal'}`}
              style={{ color: textColor }}
            >
              <span>{row.label}</span>
              <span>{row.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Right panel */}
      <div className="flex flex-col items-center justify-between w-1/2 pt-2 px-[38px]">
        <img src="./assets/images/checkout_theme_payments.png" alt="" />
        <div className="w-full">
          <div
            className="mt-1 mb-1 w-[90px] h-[80px] bg-white rounded-lg flex justify-center items-center"
            style={{ border: `1px solid ${buttonColor}` }}
          >
            <img
              src="./assets/images/checkout_theme_creditcard_box.png"
              className="w-[83px] h-[75px]"
              alt=""
            />
          </div>
        </div>
        <img src="./assets/images/checkout_theme_creditcard.png" alt="" />
        <button
          className="w-full h-10 rounded px-4 py-1 text-sm font-medium mt-2 mb-2"
          style={{ background: buttonColor, color: buttonTextColor }}
        >
          Pay $ 15.50
        </button>
        <img src="./assets/images/checkout_theme_footer.png" alt="" />
      </div>
    </div>
  );
};

export default DesktopPreview;
